//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from "./actions";

import * as IntereactionActions from "../interactions/actions";
import * as TipsActions from "../tips/actions";
import { logToSentry } from "utils/networkErrorUtils";
import { has, filter, flatMap, map, get } from "lodash";
import { handleListActivities } from 'store/activities/thunks';
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListTipsBook } from 'store/tips/thunks';
import { updateUI } from 'store/UI/actions';
import * as Sentry from '@sentry/react';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------

//  -- List books ----------------
export const handleListAllBooks = () => async (dispatch) => {
  await dispatch(ActivityActions.listAllBooks());
  const BOOK_LENGTH = 20;
  // Array.apply(0, new Array(Math.floor(53/20)+1)).map((k,i) => i)
  try {
    const numberOfBook = await apis.get("booksRDS", `/getBooksLength`);
    if (numberOfBook && numberOfBook.length) {
      const bookarr = Array.apply(
        0,
        new Array(Math.floor(numberOfBook.length / BOOK_LENGTH) + 1)
      ).map((k, i) => i);
      const allBooks = await Promise.allSettled(
        map(bookarr, async (k) => {
          return apis.get("booksRDS", `/get/${k * BOOK_LENGTH}/${BOOK_LENGTH}`);
        })
      ).then((v) => filter(v, ["status", "fulfilled"]).map((k) => k.value));
      const booksRDS = flatMap(allBooks).filter((book) => book !== null && book !== undefined);
      await dispatch(ActivityActions.listAllBooksSuccess(booksRDS));
      return booksRDS;
    } else {
      let books = [];
      const booksRDS = await apis.get("booksRDS", `/books`);
      if (Array.isArray(booksRDS) && booksRDS.length > 0) {
        books = booksRDS;
      }
      await dispatch(ActivityActions.listAllBooksSuccess(books));
      return books;
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
          message: 'Error listing all books',
          error,
          module: 'BOOKS',
          operation: 'LIST_ALL_BOOKS'
      });
    }
    await dispatch(ActivityActions.listAllBooksFail(error));
  }
};

//Bug Tips
export const handleListEbookData = (chapter) => async (dispatch) => {
  await dispatch(IntereactionActions.listChapterInteractions());
  await dispatch(TipsActions.listTipsBook());

  try {
    const booksData = await apis.get("booksRDS", `/booksData/${chapter}`);
    if (booksData && typeof booksData === "object" && !booksData?.error) {
      const tips = booksData.tips;
      const interactions = booksData.interactions;
      await dispatch(
        IntereactionActions.listChapterInteractionsSuccess(interactions)
      );
      await dispatch(TipsActions.listTipsBookSuccess(tips));
    }
    // await dispatch(ActivityActions.listAllBooksSuccess(books));
    return booksData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
          message: 'Error listing ebook data',
          error,
          module: 'BOOKS',
          operation: 'LIST_EBOOK_DATA'
      });
    }
    await dispatch(ActivityActions.listAllBooksFail(error));
  }
};

export const handleCreateBook = (bookData) => async (dispatch) => {
  await dispatch(ActivityActions.createBooks());

  try {
    const booksRDS = await apis.post("booksRDS", `/create`, {
      body: bookData,
    });
    if (booksRDS && booksRDS.success) {
      await dispatch(ActivityActions.createBooksSuccess(booksRDS.data));
      return booksRDS.data;
    } else {
      return { error: booksRDS.message || "Failed to create book" };
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'creating book',
        error,
        module: 'BOOKS',
        operation: 'CREATE_BOOK'
      });
    }
    return { error: error.message || "Failed to create book" };
  }
};
export const handleUpdateBook = (id, bookData) => async (dispatch) => {
  await dispatch(ActivityActions.updateBooks());
  try {
    const booksRDS = await apis.put("booksRDS", `/update/${id}`, {
      body: bookData,
    });

    if (has(booksRDS, "id")) {
      await dispatch(ActivityActions.updateBooksSuccess(booksRDS));
    }
    return booksRDS;
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                 message: 'updating book',
                 error,
                 module: 'BOOKS',
                 operation: 'UPDATE_BOOK'
             });
    }
  }
};
export const handleUpdateBookByPage = (chapter, pageId, fieldData, fieldname) => async (dispatch) => {
  try {
    const update_info = await apis.put("booksRDS", `/updateByPage`, {
      body: {
        chapter, pageId , fieldData, fieldname
      },
    });

    if (update_info && update_info.success) {
      await dispatch(ActivityActions.updateBooksSuccess(update_info.data));
    }
    return update_info;
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                 message: 'updating book by page',
                 error,
                 module: 'BOOKS',
                 operation: 'UPDATE_BOOK_BY_PAGE'
             });
    }
  }
};
export const handleGetBookById = (bookId) => async (dispatch) => {
  try {
    const bookInfo = await apis.get("booksRDS", `/get_book_by_id/${bookId}`);
   const infp = Array.isArray(bookInfo)? bookInfo:[];
   if(infp.length>0) {
    if(infp[0] && infp[0].id) {
       await dispatch(ActivityActions.updateBooksSuccess(infp[0]));
        return infp[0];
    }
   }
   return null;
  } catch (error) {
    if (error && error.message != "Network Error") {
      Sentry.captureException(`763 Error listing allowed books: ${error}`);
    }
  }
}

export const handleDeleteBookPage = (chapter, page) => async (dispatch) => {
  try {
    const deleteResponse = await apis.post("booksRDS", `/adjust_book_page_v2`,{
      body: {
        "chapter":chapter,
        "page":page,
        "action":"delete"
      }
    });
    
    if (deleteResponse && deleteResponse.success) {
     await dispatch(handleGetBookById(chapter));
    }
    
    return deleteResponse;
  } catch (error) {
    if (error && error.message != "Network Error") {
      Sentry.captureException(`764 Error deleting book page: ${error}`);
    }
    throw error;
  }
};

export const handleAddBookPageInMiddle = (chapter, page, type = "after") => async (dispatch) => {
  try {
    const addResponse = await apis.post("booksRDS", `/adjust_book_page_v2`,{
      body: {
        "chapter":chapter,
        "page":page,
        "action":"add",
        "type":type
      }
    });
    
    if (addResponse && addResponse.success) {
     const book_info = await dispatch(handleGetBookById(chapter));
     if(book_info&&book_info.pages){
      if(typeof addResponse === 'object'){
        addResponse.book_info = book_info;
      }
     }
    }
    
    return addResponse;
  } catch (error) {
    if (error && error.message != "Network Error") {
      Sentry.captureException(`764 Error adding book page in middle: ${error}`);
    }
    throw error;
  }
};

export const handleListBookOrder = () => async (dispatch) => {
  try {
    const bookOrder = await apis.get("booksRDS", `/listBookOrder`);
    if (has(bookOrder, "id")) {
      await dispatch(
        ActivityActions.setBookOrderSuccess(get(bookOrder, "order", []))
      );
    }
    return get(bookOrder, "order", []);
  } catch (error) {
    console.log("create book error", error);
    if (error && error.message != "Network Error") {
      logToSentry({
          message: 'Error during book order listing',
          error,
          module: 'BOOKS',
          operation: 'LIST_BOOK_ORDER'
      });
    }
    return [];
  }
};

export const handleUpdateListBookOrder = (order) => async (dispatch) => {
  // await dispatch(ActivityActions.updateBooks());
  try {
    const updateBookOrder = await apis.put("booksRDS", `/updateBookOrders`, {
      body: { order },
    });
    if (has(updateBookOrder, "id")) {
      await dispatch( ActivityActions.setBookOrderSuccess(get(updateBookOrder, "order", [])));
    }
    return updateBookOrder?.order;
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                 message: 'updating book order',
                 error,
                 module: 'BOOKS',
                 operation: 'UPDATE_BOOK_ORDER'
             });
    }
  }
};

export const handleListActiveInActiveBooks = () => async (dispatch) => {
  await dispatch(ActivityActions.listAllBooks());
  const BOOK_LENGTH = 20;

  try {
    const numberOfBook = await apis.get("booksRDS", `/allBooksLength`);
    if (numberOfBook && numberOfBook.length) {
      const bookarr = Array.apply(
        0,
        new Array(Math.floor(numberOfBook.length / BOOK_LENGTH) + 1)
      ).map((k, i) => i);
      const allBooks = await Promise.allSettled(
        map(bookarr, async (k) => {
          const offset = k * BOOK_LENGTH;
          const uniqueRequestId = `books_offset${offset}_chunk${k}_limit${BOOK_LENGTH}`;
          return apis.get(
            "booksRDS",
            `/allBookget/${offset}/${BOOK_LENGTH}?requestId=${uniqueRequestId}`
          );
        })
      ).then((v) => filter(v, ["status", "fulfilled"]).map((k) => k.value));
      const booksRDS = flatMap(allBooks).filter((book) => book !== null && book !== undefined);
      await dispatch(ActivityActions.listAllBooksSuccess(booksRDS));
      return booksRDS;
    } else {
      let books = [];
      const booksRDS = await apis.get("booksRDS", `/allBookList`);
      if (Array.isArray(booksRDS) && booksRDS.length > 0) {
        books = booksRDS;
      }
      await dispatch(ActivityActions.listAllBooksSuccess(books));
      return books;
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                 message: 'listing active in active books',
                 error,
                 module: 'BOOKS',
                 operation: 'LIST_ACTIVE_INACTIVE_BOOKS'
             });
    }
    await dispatch(ActivityActions.listAllBooksFail(error));
  }
};

export const handleActiveInActiveBook = (id, values) => async (dispatch) => {
  const booksRDS = await apis.put("booksRDS", "/stateChange", {
    body: {
      id: id,
      active: values,
    },
  });

  if (has(booksRDS, "id")) {
      await dispatch(handleListActiveInActiveBooks());
      return booksRDS
  }
};

export const hanldeCloneBooks = (id, display_name, bookImage) => async (dispatch) => {
  try {
    const response = await apis.put("booksRDS", "/clone_book_entire_data", {
      body: {
        id: id,
        display_name,
        bookImage
      },
    });
    if (response && response.success) {
      const data = response.data;
      if (data && data.id) {
        await Promise.allSettled([
          dispatch(ActivityActions.createBooksSuccess(data)),
          dispatch(handleListActivities()),
          dispatch(handleListQuizzes()),
          dispatch(handleListTipsBook()),
        ])
        return data;
      }
    }
    return null
  } catch (error) {
    console.log("error in clone", error)
    return error;
  }

};

export const handleListAllowedBooks = (userId) => async (dispatch) => {
  try {
    const permissions = await apis.get("orgPermissions", `/list_books_by_user/${userId}`);
    if (permissions && permissions.success && permissions.data && permissions.data.allowed_book) {
      await dispatch(ActivityActions.setUserAllowedBooks(permissions.data));
      return permissions.data;
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
       logToSentry({
                 message: 'listing allowed books',
                 error,
                 module: 'BOOKS',
                 operation: 'LIST_ALLOWED_BOOKS'
             });
    }
  }
}


export const handleListShareAndReciveBooks = (data) => async (dispatch) => {
  try {
    dispatch(updateUI({ listViewSharedAndReceiveBooks: {} }));
    const res = await apis.post("booksRDS", `/superLessonAndDiffList`, {
      body: {
        ...data,
      }
    });

    if(res && res.statusCode === 200){
      dispatch(updateUI({ listViewSharedAndReceiveBooks: res?.result || {} }));
      return res.result;
    }
    return {};
  } catch (error) {
     console.log("error in list share and receive books", error)
    // if (error && error.message != "Network Error") {
            logToSentry({
                 message: 'listing allowed books',
                 error,
                 module: 'BOOKS',
                 operation: 'LIST_ALLOWED_BOOKS'
             });
    // }
  }
}

export const handleListExamBooks = () => async (dispatch) => {
  try {
    const examBooks = await apis.get("booksRDS", `/get_exam_books`);
    return examBooks;
  } catch (error) {
    console.log("error in list exam books", error)
  }
}

export const handleListExternalBooks = () => async (dispatch) => {
  try {
    const externalBooks = await apis.get("booksRDS", `/list_static_book`);
    return externalBooks;
  } catch (error) {
    console.log("error in list external books", error)
  }
}
export const handleListBooksByIds = (ids,fullData = true) => async (dispatch) => {
  try {
    const externalBooks = await apis.post("booksRDS", `/get_books_by_ids?fullData=${fullData}`,{
      body: {
        ids
      }
    });
    return externalBooks;
  } catch (error) {
    console.log("error in list books by ids", error)
  }
}

export const handleGetBookByChapter = (chapter) => async (dispatch) => {
  try {
    const bookResponse = await apis.get("booksRDS", `/get_book_by_id/${chapter}`);
    if (bookResponse && Array.isArray(bookResponse) && bookResponse.length > 0 && bookResponse[0]) {  
      const book = bookResponse[0];
      if (book && book.id) {
        await dispatch(ActivityActions.updateBooksSuccess(book));
      }
      return bookResponse;
    }
    return null;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'Error fetching book by chapter',
        error,
        module: 'BOOKS',
        operation: 'GET_BOOK_BY_CHAPTER'
      });
    }
    console.log("error in get book by chapter", error);
    return null;
  }
}

export const handleListBooksCover = () => async (dispatch) => {
  await dispatch(ActivityActions.listBooksCover());
  try {
    const booksCover = await apis.get("booksRDS", `/list_books_covers`);
    if (booksCover && booksCover.success && Array.isArray(booksCover.data)) {
      await dispatch(ActivityActions.listBooksCoverSuccess(booksCover.data));
      return booksCover.data;
    } else {
      await dispatch(ActivityActions.listBooksCoverFail("Invalid response format"));
      return [];
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'Error listing books cover',
        error,
        module: 'BOOKS',
        operation: 'LIST_BOOKS_COVER'
      });
    }
    await dispatch(ActivityActions.listBooksCoverFail(error));
    return [];
  }
}

export const handleUpdateBookGrade = (id, gradeData) => async (dispatch) => {
  try {
    const booksRDS = await apis.put("booksRDS", `/update/${id}/grade`, {
      body: gradeData,
    });
    if (has(booksRDS, "id")) {
      await dispatch(ActivityActions.updateBooksSuccess(booksRDS));
      await dispatch(handleListAllBooks());
    }
    return booksRDS;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'updating book grade',
        error,
        module: 'BOOKS',
        operation: 'UPDATE_BOOK_GRADE'
      });
    }
    return { error: error.message };
  }
}

export const handleGetGradeLevel = (state) => async (dispatch) => {
  try {
    const gradeLevel = await apis.get("booksRDS", `/getGradeLevel/${state}`);
    return gradeLevel;
  } catch (error) {
    console.log("error in get grade level", error)
  }
}

export const handleActivityGradeConfig = (data) => async (dispatch) => {
  try {
    const activityGradeConfig = await apis.post("story", `/activityGradeConfig`, {
      body: {
        ...data
      }
    });
    return activityGradeConfig;
  }
  catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'updating book grade',
        error,
        module: 'BOOKS',
        operation: 'UPDATE_BOOK_GRADE'
      });
    }
    return { error: error.message };
  }
}

export const handleCheckActivityCount = (data) => async (dispatch) => {
  try {
    const activityCount = await apis.post("story", `/checkActivityCount`, {
      body: {
        ...data
      }
    });
    return activityCount;
  }
  catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'checking activity count',
        error,
        module: 'BOOKS',
        operation: 'CHECK_ACTIVITY_COUNT'
      });
    }
    return { error: error.message };
  }
}

export const handleListActiveBooksByClass = (data) => async (dispatch) => {
  try {
    const booksRDS = await apis.post("booksRDS", `/list_active_books_by_class`, {
      body: data,
    });
    return booksRDS?.data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'listing active books by class',
        error,
        module: 'BOOKS',
        operation: 'LIST_ACTIVE_BOOKS_BY_CLASS'
      });
    }
    return { error: error.message };
  }
}